import { useEffect, useState } from 'react';
import { parse as deserializeQueryParams } from "query-string";
import { IAuthApi, IAuthPlugin } from 'shared/mechanics/auth';

import styles from './Button.module.scss'

export interface AuthButtonProps {
	provider: IAuthPlugin;
	buttonClassName: string;
	iconClassName: string;
}

export const AuthButton = (props: AuthButtonProps) => {
	const [authenticationApi, setAuthenticationApi] = useState<IAuthApi | null>(null);

	useEffect(() => { props.provider.useAuthentication().then(setAuthenticationApi); }, []);

	const onAuthClick = () => {
		if (authenticationApi == null) {
			alert('Повторите снова! Кнопка не успела до конца прогрузиться, дайте ей хотя бы 2 секунды.')
			return;
		}

		authenticationApi.signIn().then(
			() => {
				const queryParams = deserializeQueryParams(document.location.search);
				const redirectUrl = queryParams ? queryParams['redirectUrl']?.toString() : null;
				if (redirectUrl)
					window.location.href = document.location.origin + redirectUrl;
				else
					window.location.reload();
			},
			() => alert('Не удалось войти в систему указанным способом. Попробуйте перезагрузить страницу и повторить попытку.'));
	}

	return (
		<button className={`${styles.button} ${props.buttonClassName}`} onClick={onAuthClick}>
			<i className={props.iconClassName}></i>
			Войти через {props.provider.displayName}
		</button>
	);
}
